import React, { useState, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';

interface ApiCallsSummary {
    todayApiCalls: number;
    yesterdayApiCalls: number;
    last7DaysApiCalls: number;
    last30DaysApiCalls: number;
}

const UsageMetrics = () => {
    const [summary, setSummary] = useState<ApiCallsSummary>({
        todayApiCalls: 0,
        yesterdayApiCalls: 0,
        last7DaysApiCalls: 0,
        last30DaysApiCalls: 0,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSummary();
    }, []);

    const fetchSummary = async () => {
        try {
            setLoading(true);
            const apiClient = new APIClient();
            const response: any = await apiClient.get('/dashboard/production-api-calls-summary');

            if (response?.code === 200 && response?.data) {
                setSummary(response.data);
            }
        } catch (error) {
            console.error('Error fetching production API calls summary:', error);
        } finally {
            setLoading(false);
        }
    };

    const val = (v: number) => (loading ? '...' : v.toLocaleString());

    const stats = [
        { label: 'Today', value: summary.todayApiCalls, icon: 'ri-calendar-todo-line', color: 'primary' },
        { label: 'Yesterday', value: summary.yesterdayApiCalls, icon: 'ri-calendar-line', color: 'info' },
        { label: 'Last 7 Days', value: summary.last7DaysApiCalls, icon: 'ri-bar-chart-grouped-line', color: 'warning' },
        { label: 'Last 30 Days', value: summary.last30DaysApiCalls, icon: 'ri-bar-chart-2-line', color: 'success' },
    ];

    return (
        <Card className="card-animate h-100">
            <CardBody>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                            API Calls
                            <span className="badge bg-success-subtle text-success ms-2 text-lowercase fw-normal">
                                🟢 Production
                            </span>
                        </p>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="avatar-sm rounded">
                            <div className="avatar-title bg-success-subtle text-success fs-20 rounded">
                                <i className="ri-bar-chart-line"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-3 mt-2">
                    {stats.map((stat) => (
                        <div key={stat.label} className="col-3">
                            <div className={`p-2 border border-${stat.color}-subtle rounded text-center`}>
                                <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
                                    <i className={`${stat.icon} text-${stat.color} fs-16`}></i>
                                    <span className="text-muted fs-12 text-truncate">{stat.label}</span>
                                </div>
                                <h5 className={`mb-0 fw-semibold text-${stat.color}`}>
                                    {val(stat.value)}
                                </h5>
                            </div>
                        </div>
                    ))}
                </div>
            </CardBody>
        </Card>
    );
};

export default UsageMetrics;
